document.addEventListener('DOMContentLoaded', function() {

  /* Bloquear scroll al abrir drawer sin salto */
  var scrollY = 0;

  $(document.body).on('drawer.open', function() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
  });

  $(document.body).on('drawer.close', function() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, scrollY);
  });

});
document.addEventListener('DOMContentLoaded', function() {
	var bar = document.querySelector('.nkoda-mobile-search-bar');
	var header = document.querySelector('.header-mobile .header-top-mobile');

	function positionBar() {
		if (bar && header) {
			bar.style.top = header.getBoundingClientRect().bottom + 'px';
		}
	}

	document.querySelectorAll('.js-header-search-mobile-toggle').forEach(function(el) {
		el.addEventListener('click', function(e) {
			e.preventDefault();
			positionBar();
			document.body.classList.toggle('modal-search--open');
			if (document.body.classList.contains('modal-search--open')) {
				var input = bar.querySelector('.nkoda-mobile-search-input');
				if (input) setTimeout(function(){ input.focus(); }, 100);
			}
		});
	});

	window.addEventListener('resize', positionBar);
});